import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { EnumFormControlProps } from '@/pages/WorkflowsCatalog/components/run/controls/types';
import type { FieldValues } from 'react-hook-form';

const CLEAR_VALUE = '__clear__';

const EnumFormControl = <T extends FieldValues>({ field, options }: EnumFormControlProps<T>) => {
  return (
    <Select
      onValueChange={(val) => field.onChange(val === CLEAR_VALUE ? undefined : val)}
      value={field.value as string | undefined}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        {field.value && (
          <SelectItem value={CLEAR_VALUE} className="text-muted-foreground italic">
            Clear selection
          </SelectItem>
        )}
        {options.map((option: string) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default EnumFormControl;
